import { MutationHookOptions, useMutation } from '@apollo/client';

import { CANCEL_AGREEMENT_MUTATION } from '@frontend/app/queries';
import { CancelAgreement, CancelAgreementVariables } from '../queries/types/CancelAgreement';

type IOptions = MutationHookOptions<CancelAgreement, CancelAgreementVariables>;

export const useCancelAgreementMutation = (options: IOptions = {}) => useMutation(CANCEL_AGREEMENT_MUTATION, options);
